"use strict";

import angular from "angular";

import template from "./chart-visualization-score.component.html";
import "./themes/chart-visualization-score-dark.component.scss";
import "./themes/chart-visualization-score.component.scss";

import _ from "lodash";

import { Company } from "../../../gateway/Company/Company";
import { ScoreAccounting } from "../../../gateway/ScoreAccounting/ScoreAccounting";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";
import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";
import { PointsAccountingAnalytics } from "../../../presentation/services/PointsAccountingAnalytics/PointsAccountingAnalytics";
import * as DateUtils from "../../../utils/date/date";

class ChartVisualizationScoreComponent {
    constructor($filter) {
        this.Company = new Company();
        this.PointsAccountingAnalytics = new PointsAccountingAnalytics();
        this.ScoreAccounting = new ScoreAccounting({
            PointsAccountingAnalytics: this.PointsAccountingAnalytics
        });
        this.FormatUnits = new FormatUnits($filter);
        this.CalculatingMachine = new CalculatingMachine();

        this.scoreValue = 0;
        this.points = [];
        this.scoreLabel = "";
        this.comparationValue = {
            name: "",
            comparationValue: "",
            percentage: 0,
            value: 0,
            polarityColor: "",
            variationCondition: "",
            tooltipValue: 0,
            unit: ""
        };
    }

    $onInit() {
        this._setPoints();
        this._setViewValues();
    }

    $onChanges(changes) {
        if (
            typeof _.get(changes, "currentDate.previousValue") != "object" ||
            typeof _.get(changes, "currentFilters.previousValue") != "object"
        ) {
            this._setPoints();
            this._setViewValues();
        }
    }

    $onDestroy() {}

    openShowtime() {
        this.onOpenShowtime({ visualizationId: this.visualizationId });
    }

    _getFormattedDate(date = this.currentDate) {
        const [year, month] = date.split("-");

        const regularMonth = String(month).padStart(2, "0");

        return new Date(`${year}-${regularMonth}-01`);
    }

    _setPoints() {
        const points = this.ScoreAccounting.PointsAccountingAnalytics.findCollection(
            {
                a: this.accountingId,
                s: "SCORE_ACCOUNTING",
                t: { $lte: this._getFormattedDate() }
            }
        );

        this.points = _.get(points, "list", []);
    }

    _setScoreValue(point) {
        this.scoreValue = _.get(point, "m.total", 0);
        this.scoreValueFormatted = this.FormatUnits.formatValue(
            "percentage",
            _.get(point, "m.total", 0),
            0
        );
    }

    _setScoreLabel(point) {
        const labels = {
            ALTO: "Alto",
            MEDIO: "Médio",
            BAIXO: "Baixo"
        };

        this.scoreLabel = labels[_.get(point, "m.label", "")];
    }

    _setViewValues(points = this.points) {
        const lastPoint = _.last(points);

        this._setScoreValue(lastPoint);
        this._setScoreLabel(lastPoint);

        this._setComparationValue(points);
    }

    _setComparationValue(points) {
        const date = this._getFormattedDate();

        const currentMonth = String(date.getUTCMonth() + 1).padStart(2, "0");

        const currentPoint = _.findLast(points, (p) => {
            return (
                `${p.t.getUTCFullYear()}${String(
                    p.t.getUTCMonth() + 1
                ).padStart(2, "0")}` ===
                `${date.getUTCFullYear()}${currentMonth}`
            );
        });

        const previousDate = DateUtils.getPreviousMonth(
            new Date(`${date.getUTCFullYear()}-${currentMonth}-01`),
            1
        );

        //const endOfMonth = DateUtils.getEndOfMonth(previousDate);

        const comparationMonth = String(
            previousDate.getUTCMonth() + 1
        ).padStart(2, "0");

        const comparationPoint = _.findLast(points, (p) => {
            return (
                `${p.t.getUTCFullYear()}${String(
                    p.t.getUTCMonth() + 1
                ).padStart(2, "0")}` ===
                `${previousDate.getUTCFullYear()}${comparationMonth}`
            );
        });

        const _pointValueX = _.get(currentPoint, "m.total") || 0;
        const _pointValueY = _.get(comparationPoint, "m.total") || 0;

        const value = _pointValueX - _pointValueY;

        const percentage = value / _pointValueY;

        const variationCondition = this.CalculatingMachine.variationCondition(
            _pointValueX,
            _pointValueY,
            1
        );

        const polarityColor = this.CalculatingMachine.polarityColor(
            {
                polarity: 1,
                current: _pointValueX,
                prev: _pointValueY,
                value
            },
            false,
            variationCondition
        );

        this.comparationValue = {
            name: "Nucont Score",
            comparationValue: this.FormatUnits.formatValue(
                "int",
                _pointValueX,
                "2"
            ),
            percentage: isNaN(percentage) ? 0 : percentage,
            value,
            polarityColor,
            variationCondition,
            tooltipValue: 0,
            unit: "int",
            currentPeriod: { date, period: "monthly" },
            currentComparation: { date: previousDate, period: "monthly" }
        };
    }
}

export { ChartVisualizationScoreComponent };

ChartVisualizationScoreComponent.$inject = ["$filter"];

const name = "chartVisualizationScoreComponent";
const def = {
    controller: ChartVisualizationScoreComponent,
    bindings: {
        accountingId: "<",
        currentDate: "<",
        currentFilters: "<",
        onOpenShowtime: "&",
        visualizationId: "<",
        hideShowtime: "<",
        chartHeight: "@"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
